import React from 'react';

import PropTypes from 'prop-types';

import CustomCheckbox from './CustomCheckbox';

const AllDayCheckbox = ({
  form: { getFieldDecorator, setFieldsValue },
  initialValue = true,
  ...props
}) => (
  <React.Fragment>
    {getFieldDecorator('allDay', {
      valuePropName: 'checked',
      initialValue,
    })(<CustomCheckbox setFieldsValue={setFieldsValue} {...props} />)}
  </React.Fragment>
);

AllDayCheckbox.propTypes = {
  form: PropTypes.object.isRequired,
  initialValue: PropTypes.bool,
};

export default AllDayCheckbox;
